<template>
  <div class="mk-banner-container">
    <img :src="childItem.propsValue.data.customField1" width="100%" height="100%" />
    <a
      v-if="childItem.propsValue.data.customField2.text"
      href="javascript:void(0);"
      class="gotoFrom"
    >
      {{
      childItem.propsValue.data.customField2.text
      }}
    </a>
  </div>
</template>

<script>
let buttonDataObject = {
  text: "按钮",
  beforeClick: {
    type: 0, // 0 直接访问使用， 1 填写表单后有效
    form: "", // 表单ID，按钮点击需填写表单
    formtime: "无" // 表单有效期  无 一天 七天 永久
  },
  afterClick: {
    type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
    url: "",
    contentType: "data", // data 资料， article 文章， video 视频
    contentId: ""
  }
};
export default {
  name: "MkBannerPhone",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 750,
          height: 550
        },
        {
          code: "customField2",
          label: "按钮",
          type: "button"
        }
      ],
      data: {
        customField1:
          "https://mks.yybip.com/group1/M00/00/C0/CgoRDGLPriCAVFr5AAWf4s9_hlI342.png",
        customField2: JSON.parse(JSON.stringify(buttonDataObject))
      }
    };
  }
};
</script>

<style scoped lang="scss">
.mk-banner-container {
  width: 100%;
  height: 100%;
  position: relative;
  a {
    display: block;
    position: absolute;
    top: 220px;
    left: 20px;
    font-size: 14px;
    width: 158px;
    text-align: center;
    height: 38px;
    line-height: 38px;
    color: #fff;
    background-image: linear-gradient(to right, #e6732d, #e31923);
    border-radius: 5px;
  }
}
</style>
